import { useSession } from '@/hooks/useSession';
import { Icon } from './Icon';

/**
 * Плашка «Мой портфель · N клиентов» внизу сайдбара (как в макете). Размер
 * портфеля – реальный (meta.total /clients, тот же скоуп по tutors, что и в
 * списке клиентов), загружен один раз в RootGate; без него плашку не
 * показываем – выдумывать число не из чего.
 */
export function PortfolioChip() {
  const { portfolioSize } = useSession();

  if (portfolioSize === null) return null;

  return (
    <div className="portfolio-chip">
      <Icon name="square" size={13} />
      <span>Мой портфель · {portfolioSize} клиентов</span>
    </div>
  );
}
